// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__356aK","footer":"styles_footer__ErBfM","passCodeTooltip":"styles_passCodeTooltip__Jn7Uy"};